import axios from 'axios';
import { splitSalesOrderLines } from '@/utils/salesOrderLines';

export const salesOrderService = {
  async list({ dealId, projectId } = {}) {
    const response = await axios.get('/sales-orders', {
      params: {
        deal_id: dealId || undefined,
        project_id: projectId || undefined,
      },
    });
    return response.data?.sales_orders || [];
  },

  async getById(id) {
    const response = await axios.get(`/sales-orders/${id}`);
    return response.data;
  },

  /**
   * Lines from SalesOrderLinesEditor: configured products and free lines.
   * Either dealId or leadId identifies the customer.
   */
  async create({ dealId = null, leadId = null, lines = [], project = {} }) {
    const response = await axios.post('/sales-orders', {
      deal_id: dealId || undefined,
      lead_id: leadId || undefined,
      ...splitSalesOrderLines(lines),
      project,
    });
    return response.data;
  },

  async cancelPreview(id) {
    const response = await axios.get(`/sales-orders/${id}/cancel-preview`);
    return response.data;
  },

  async cancel(id) {
    const response = await axios.post(`/sales-orders/${id}/cancel`);
    return response.data;
  },

  async revertPreview(proposalId, action) {
    const response = await axios.get('/sales-orders/revert-preview', {
      params: { proposal_id: proposalId, action },
    });
    return response.data;
  },
};
